import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import SupplierOrders from '../components/SupplierOrders';


const mapStateToProps = (state: RootState) => ({
    getSupplierOrdersBusy: state.supplierRdc.getSupplierOrdersBusy,
    supplierOrders: state.supplierRdc.supplierOrders,
})


export type SupplierOrdersProps = ReturnType<typeof mapStateToProps>

export const SupplierOrdersCnn = connect(
    mapStateToProps
)(SupplierOrders);